'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/12/2.
                                          */

// import {add, clearAdd} from 'redux/modules/attentionDesigner';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HeaderPreview = require('../Header/HeaderPreview');

var _HeaderPreview2 = _interopRequireDefault(_HeaderPreview);

var _reactRedux = require('react-redux');

var _designerDetail = require('redux/modules/designerDetail');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesignerDetailPreview = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!(0, _designerDetail.isPreviewLoaded)(getState())) {
      var promises = [];
      promises.push(dispatch((0, _designerDetail.loadPreview)(params.designerId)));
      promises.push(dispatch((0, _background.changeHeaderText)('作者主页预览')));
      return _promise2.default.all(promises);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.designerDetail.previewData,
    attentionData: state.attentionDesigner.addData
  };
}, {
  routerPush: _reactRouterRedux.push
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DesignerDetailPreview, _Component);

  function DesignerDetailPreview() {
    (0, _classCallCheck3.default)(this, DesignerDetailPreview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DesignerDetailPreview).call(this));

    _this.state = {
      headerActiveIndex: 0
    };
    return _this;
  }

  (0, _createClass3.default)(DesignerDetailPreview, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.state.headerActiveIndex = null;
    }
  }, {
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'isContentToShow',
    value: function isContentToShow(item) {
      for (var _index = 0; _index < item.length; _index++) {
        if (item[_index].img) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var headerActiveIndex = this.state.headerActiveIndex;
      var _props = this.props;
      var data = _props.data;
      var location = _props.location;

      var designerTxt = '设计师简介';
      if (location) {
        var query = location.query;

        if (query) {
          var isCustom = query.isCustom;

          if (isCustom === '0') {
            designerTxt = '作者简介';
          }
        }
      }
      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        var designerInfoHome = data.designerInfoHome;
        var designerInfoIntro = data.designerInfoIntro;
        var designerInfoStory = data.designerInfoStory;
        var designerInfoHonor = data.designerInfoHonor;
        var designerInfoProduct = data.designerInfoProduct;

        var styles = require('../ProductDetails/ProductDetails.scss');

        var anchors = ['productDetailFirstPage'];
        var array = [{
          /*  text: '艺品详情',
           type: 'pop',
           icon: 'icon01',
           onClick: '' */
          text: '首页',
          href: 'productDetailFirstPage',
          type: 'nav',
          icon: 'icon01'
        }];

        var contentDiv = [_react2.default.createElement(
          _components.FullPageSection,
          { key: '0', className: styles.goeasySection },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(_HeaderPreview2.default, null)
          ),
          designerInfoHome instanceof Array && this.isContentToShow(designerInfoHome) ? _react2.default.createElement(
            'div',
            { className: styles.firstFullPageItem },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true, images: designerInfoHome })
          ) : ''
        )];

        if (designerInfoIntro instanceof Array && designerInfoIntro.length > 0) {
          if (this.isContentToShow(designerInfoIntro)) {
            anchors.push('designerInfoIntro');
            array.push({
              text: designerTxt,
              href: 'designerInfoIntro',
              type: 'nav',
              index: 1,
              className: 'back2',
              icon: 'icon02'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '1', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: designerInfoIntro })
            ));
          }
        }

        if (designerInfoStory instanceof Array && designerInfoStory.length > 0) {
          if (this.isContentToShow(designerInfoStory)) {
            anchors.push('designerInfoStory');
            array.push({
              text: '故事',
              href: 'designerInfoStory',
              type: 'nav',
              index: 2,
              icon: 'icon05'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '2', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: designerInfoStory })
            ));
          }
        }

        if (designerInfoHonor instanceof Array && designerInfoHonor.length > 0) {
          if (this.isContentToShow(designerInfoHonor)) {
            anchors.push('designerInfoHonor');
            array.push({
              text: '荣誉',
              href: 'designerInfoHonor',
              type: 'nav',
              index: 3,
              icon: 'icon07'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '3', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: designerInfoHonor })
            ));
          }
        }

        if (designerInfoProduct instanceof Array && designerInfoProduct.length > 0) {
          if (this.isContentToShow(designerInfoProduct)) {
            anchors.push('designerInfoProduct');
            array.push({
              text: '作品',
              href: 'designerInfoProduct',
              type: 'nav',
              index: 4,
              icon: 'icon06'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '4', className: styles.goeasySection },

              //  <AccordionComponent images={designerInfoProduct} type="preview"/>
              designerInfoProduct instanceof Array && designerInfoProduct.length > 0 ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: designerInfoProduct }) : ''
            ));
          }
        }
        var options = {
          sectionClassName: 'section',
          anchors: anchors,
          scrollBar: false,
          activeClass: styles.active,
          navigation: false,
          verticalAlign: false,
          sectionPaddingTop: '0',
          sectionPaddingLeft: '0',
          sectionPaddingRight: '0',
          sectionPaddingBottom: '0'
        };

        resultDiv = _react2.default.createElement(
          'div',
          { className: styles.component },
          headerActiveIndex === 0 ? _react2.default.createElement(
            'a',
            { className: styles.nextIcon, href: '#designerInfoIntro' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
          ) : '',
          _react2.default.createElement(
            _components.FullPageHeader,
            null,
            _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
          ),
          _react2.default.createElement(
            _components.FullPageSectionsContainer,
            (0, _extends3.default)({ activeChange: this.activeChange.bind(this),
              className: 'container' }, options),
            contentDiv
          )
        );
      }
      return resultDiv;
    }
  }]);
  return DesignerDetailPreview;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  dispatch: _react.PropTypes.func,
  location: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = DesignerDetailPreview;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/DesignerDetailPreview/DesignerDetailPreview.js
 ** module id = 1460
 ** module chunks = 0
 **/